import { CreateChatDefinition } from "@super-real/types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const createChatCallable = getCallable(CreateChatDefinition);
